<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranIdStranka="GetPorabaProstoraHramba"
                           :permissionIdPrikljucki="permissionIdPrikljucki"
                           :filter="filter"
                           :disabled="nalganjePodatkovPorabaProstora"/>
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div>
      <div class="vsebina-postavitev">
        <div class="odmik-vsebine">
            <p class="open-sans-30pt">
              Poraba prostora
            </p>
          <div style="padding-top: 10px">
            <p class="navadno-besedilo">
              Horizont je vaš oblak za shranjevanje vsebin. Skupni prostor lahko porabljate za T-2
              snemalnik, elektronsko pošto ali za shranjevanje osebnih vsebin, kot so fotografije, video
              posnetki ali druge dokumente. Do Horizonta lahko dostopate
              <span class="primarna-barva">
                  preko mobilne aplikacije
              </span> T-2 Horizont ali
              <a :href="povezavaAvditorij" class="primarna-barva">
                spletnega vmesnika</a>.
              S funkcijo Avditorij lahko izbrane vsebine delite tudi na TV vmesniku.
            </p>
            <div class="prikaz-besedila">

            <div>
              <p class="navadno-besedilo odmik-besedila-zgoraj">
                Več o Hrambi na
                <a :href="povezavaHorizontSpletnaStran" class="primarna-barva"
                   style="cursor: pointer;" target="_blank">
                  https://www.t-2.net/horizont
                </a>
              </p>
            </div>
              <div>
                <div class="odmik-kolicine-ki-je-na-voljo">
                  <p class="navadno-besedilo">
                    Količina vključenega prostora:
                    <b>
                      {{ kolicinaKiJeNaVoljo }} GB
                    </b>
                  </p>
                  <komponenta-diagram-porabe
                    v-if="skupnaKolicina !== null && podatkiPorabaHrambaSkupaj"
                    :skupaj="kolicinaKiJeNaVoljo"
                    :zaseden-prostor="podatkiPorabaHrambaSkupaj"
                    :nezaseden-prostor="skupnaKolicina">
                  </komponenta-diagram-porabe>
                </div>
              </div>
            <div v-loading="nalganjePodatkovPorabaProstora" class="velikost-podatkov">
              <div style="padding-bottom: 10px">
                <table>
                  <tr style="padding-top: 10px">
                    <td class="navadno-besedilo">
                      Hramba
                    </td>
                    <td class="navadno-besedilo zgornji-odmik">
                      {{ izracunHramba }} GB
                    </td>
                  </tr>
                  <tr style="padding-top: 10px">
                    <td class="navadno-besedilo">
                      Avditorij
                    </td>
                    <td class="navadno-besedilo zgornji-odmik">
                      {{ izracunAvditorij }} GB
                    </td>
                  </tr>
                  <tr>
                    <td class="navadno-besedilo zgornji-odmik">
                      Elektronska pošta
                    </td>
                    <td class="zgornji-odmik navadno-besedilo">
                      {{ izracunElektronskaPosta }} GB
                    </td>
                  </tr>
                  <tr>
                    <td class="navadno-besedilo zgornji-odmik">
                      TV snemalnik
                    </td>
                    <td class="navadno-besedilo zgornji-odmik">
                      {{ izracunSnemalnik }} GB
                    </td>
                  </tr>
                  <tr>
                    <td class="navadno-besedilo zgornji-odmik">
                      <b>
                        Skupno zaseden prostor
                      </b>
                    </td>
                    <td class="navadno-besedilo zgornji-odmik">
                      <b >
                        {{ podatkiPorabaHrambaSkupaj }} GB
                      </b>
                    </td>
                  </tr>
                </table>
              </div>
              <hr class="hr-stil velikost-hr"/>
              <div style="padding-top: 10px">
                <table>
                  <tr>
                    <td class="navadno-besedilo">
                      <b>
                        Nezaseden prostor
                      </b>
                    </td>
                    <td class="pisava-pomaknjena-na-center navadno-besedilo">
                      <b style="display: inline-block;">
                        {{ (skupnaKolicina) }} GB
                      </b>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            </div>
            <div v-if="zaokrozenPodatekPorabeHramba > 80">
              <div class="odmik-premalo-prostora">
                <div>
                  <ul>
                    <li>
                      <img src="/static/img/Poraba/PorabaHramba/Icon-awesome-info-circle.png">
                      <span class="navadno-besedilo">
                        <b v-if="zaokrozenPodatekPorabeHramba <= 99">
                            Kmalu vam bo zmanjkalo prostora. Povečajte ga!
                        </b>
                        <b v-else>
                          Zmanjkalo je prostora. Povečajte ga!
                        </b>
                      </span>
                    </li>
                  </ul>
                  <div class="stil-gumba-naroci-hramba">
                    <a href="/Naroci/NarociHramba">
                      <el-button type="primary" class="gumb-potrdi">
                        NAROČI HRAMBO
                      </el-button>
                    </a>
                  </div>
                </div>
              </div>
              <div style="clear: both"/>
              <div>
                <hr class="hr-stil"/>
              </div>
            </div>
            <div v-else class="odmik-info-komponente-od-grafa">
              <div style="clear: both"/>
              <div>
                <hr class="hr-stil"/>
              </div>
            </div>
          </div>
          <div style="padding-top: 20px">
            <KomponentaPorabeHrambeAplikacije/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {povezave} from '../../../../assets/js/Povezave/povezave'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import CircleChartCard from 'src/components/UIComponents/Cards/CircleChartCard.vue'
import lang from 'element-ui/lib/locale/lang/sl'
import locale from 'element-ui/lib/locale'
import {Button, Select, Option, CollapseItem, Collapse, Table, TableColumn, Progress} from 'element-ui'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import KomponentaPorabeHrambeAplikacije from './PorabaHramba/KomponentaPorabeHrambeAplikacije'
import KomponentaDiagramPorabe from './PorabaHramba/KomponentaDiagramPorabe'

locale.use(lang)
export default {
  name: 'Ambasador',
  data () {
    return {
      clientAgent: null,
      izbranIdStranka: '',
      seznamPrikljuckov: '',
      podatkiPorabaHrambaSkupaj: 0,
      porabaHramba: 0,
      porabaAvditorij: 0,
      porabaEmail: 0,
      prikazGrafa: '1',
      porabaSnemalnik: 0,
      izracunHramba: '',
      izracunAvditorij: '',
      izracunSnemalnik: '',
      izracunElektronskaPosta: '',
      vklopljenHorizont: null,
      kolicinaKiJeNaVoljo: null,
      skupnaKolicina: null,
      nalganjePodatkovPorabaProstora: false,
      nalaganjeNazivaPorabaHorizont: false,
      procentiRacunPorabe: '',
      zaokrozenPodatekPorabeHramba: '',
      povezavaHorizontPortal: '',
      povezavaAvditorij: '',
      povezavaHorizontSpletnaStran: '',
      permissionIdPrikljucki: 'PRIKLJUCKI',
      filter: '[tip_prikljucka]=FIX'
    }
  },
  components: {
    KomponentaDiagramPorabe,
    KomponentaPorabeHrambeAplikacije,
    'IzbirnikStranke': IzbirnikStranke,
    [Button.name]: Button,
    [Select.name]: Select,
    [Option.name]: Option,
    [CollapseItem.name]: CollapseItem,
    [Collapse.name]: Collapse,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Progress.name]: Progress,
    CircleChartCard
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.GetWindowWidth)
      this.GetWindowWidth()
    })
    this.povezavaHorizontPortal = povezave.BASE_URL_HORIZONT_PORTAL
    this.povezavaHorizontSpletnaStran = povezave.BASE_URL_HORIZONT_SPLETNA_STRAN
    this.povezavaAvditorij = povezave.BASE_URL_AVDITORIJ
  },
  methods: {
    GetWindowWidth () {
      if (document.documentElement.clientWidth < 1080) {
        this.prikazGrafa = '0'
      } else {
        this.prikazGrafa = '1'
      }
    },
    GetPorabaProstoraHramba (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.idStranka = ''
        this.idStranka = prenosniParamIdStranka
        this.nalganjePodatkovPorabaProstora = true
        this.skupnaKolicina = null
        this.kolicinaKiJeNaVoljo = null
        this.podatkiPorabaHrambaSkupaj = null
        let param = ['idStranka=' + prenosniParamIdStranka]
        this.clientAgent.postWsRequest(
          this,
          '/stranka/storitve/porabaProstoraInfo?',
          param,
          null,
          'SetPorabaProstoraHramba',
          'ErrPorabaProstoraHramba')
      }
    },
    SetPorabaProstoraHramba (podatki) {
      const gbToBFaktor = 1073741824
      this.podatkiPorabaHrambaSkupaj = parseInt((podatki.data.skupaj / gbToBFaktor).toFixed(0))
      for (let i = 0; i < Object.keys(podatki.data.prikljucki).length; i++) {
        for (let prompt in podatki.data.prikljucki) {
          this.porabaHramba = podatki.data.prikljucki[prompt].hramba
          this.porabaAvditorij = podatki.data.prikljucki[prompt].avditorij
          this.porabaEmail = podatki.data.prikljucki[prompt].email
          this.porabaSnemalnik = podatki.data.prikljucki[prompt].snemalnik
          this.IzracunVrednosti()
        }
      }
      this.GetVklopljeneStoritve()
      this.nalganjePodatkovPorabaProstora = false
    },
    ErrPorabaProstoraHramba (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowErrorMessage(paramObvestilo)
      this.nalganjePodatkovPorabaProstora = false
    },
    IzracunVrednosti () {
      const gbToBFaktor = 1073741824
      this.izracunHramba = (this.porabaHramba / gbToBFaktor).toFixed(0)
      this.izracunAvditorij = (this.porabaAvditorij / gbToBFaktor).toFixed(0)
      this.izracunSnemalnik = ((this.porabaSnemalnik / gbToBFaktor).toFixed(0))
      this.izracunElektronskaPosta = (this.porabaEmail / gbToBFaktor).toFixed(0)
    },
    GetVklopljeneStoritve () {
      if (this.idStranka !== '') {
        this.nalaganjeNazivaPorabaHorizont = true
        let param = ['idStranka=' + this.idStranka]
        param.push('idVrsta[]= 103')
        param.push('idStatus=1')
        this.vklopljenHorizont = null
        this.clientAgent.postWsRequest(
          this,
          '/stranka/storitve/info',
          param,
          null,
          'SetTrenutnoIzbraneStoritve',
          'ErrMessage')
      }
    },
    SetTrenutnoIzbraneStoritve (podatki) {
      if (podatki.seznamStoritev.length > 0) {
        for (let i = 0; i < podatki.seznamStoritev.length; i++) {
          if (podatki.seznamStoritev[i].idVrsta === 103 && podatki.seznamStoritev[i] !== null) {
            this.vklopljenHorizont = podatki.seznamStoritev[i].naziv
          }
        }
      }
      this.GetProstorNaVoljo()
      this.nalaganjeNazivaPorabaHorizont = false
    },
    GetProstorNaVoljo () {
      if (this.idStranka !== '') {
        let param = ['idStranka=' + this.idStranka]
        this.kolicinaKiJeNaVoljo = null
        this.skupnaKolicina = null
        this.clientAgent.postWsRequest(
          this,
          '/stranka/storitve/prostorNaVoljo?',
          param,
          null,
          'SetGetProstorNaVoljo',
          'ErrMessage')
      }
    },
    SetGetProstorNaVoljo (podatki) {
      this.procentiRacunPorabe = ''
      this.kolicinaKiJeNaVoljo = podatki.data.skupnaKolicina
      this.skupnaKolicina = this.kolicinaKiJeNaVoljo - this.podatkiPorabaHrambaSkupaj
      if (this.skupnaKolicina < 0) {
        this.skupnaKolicina = 0
      }
      this.procentiRacunPorabe = this.podatkiPorabaHrambaSkupaj * 100 / this.kolicinaKiJeNaVoljo
      this.zaokrozenPodatekPorabeHramba = Math.round(this.procentiRacunPorabe)
    },
    ErrMessage (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowErrorMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../static/css/Poraba/PorabaHramba/PorabaHramba.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Poraba/PorabaHramba.vue